import { render, staticRenderFns } from "./ModalVincularCamadasEmLote.vue?vue&type=template&id=052f9380&lang=pug"
import script from "./ModalVincularCamadasEmLote.vue?vue&type=script&lang=js"
export * from "./ModalVincularCamadasEmLote.vue?vue&type=script&lang=js"
import style0 from "./ModalVincularCamadasEmLote.vue?vue&type=style&index=0&id=052f9380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports